var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page page-join-us"},[_c('company-intro-nav-bar',{attrs:{"hide-join-us":""}}),(_vm.content)?_c('rich-text',{staticClass:"join-us-content",attrs:{"content":_vm.content}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }